import React, { useState, useEffect } from "react";
import { ListElement } from "./box-lista-style.js";
import api from "../../services/api.js";
import { toast } from "react-toastify";
import Cancelar from "../../assets/cancelar.svg";
import edit from "../../assets/editTable.svg";
import Modal from "../modal/modal.js";
import ReactLoading from "react-loading";
import { TextAreaModal, TextDivModal } from "../TextField/styles.js";

import "../../global-styles.css";
import { toastProps } from "../../utils/toastProps.js";
import { ContainerHeaderTable } from "../HeaderTable/styles.js";
import { IconImage, TextTable } from "./styles.js";

function BoxMarca({ nome, descricao, imagem, id, GetMarcas }) {
    const [deletarMarcaIsOpen, setDeletarMarcaIsOpen] = useState(false);
    const [modalEditarIsOpen, setModalEditarIsOpen] = useState(false);
    const [changeImageIn, setChangeImageIn] = useState(false);
    const [novaImagem, setNovaImagem] = useState([]);
    const [novaImagemName, setNovaImagemName] = useState("");
    const [novoNome, setNovoNome] = useState(nome);
    const [novoDescricao, setNovoDescricao] = useState(descricao);
    const [loading, setLoading] = useState(false);
    const [loadingUpload, setLoadingUpload] = useState(false);
    const [produtosMarca, setProdutosMarca] = useState([]);
    const [loadingProdutos, setLoadingProdutos] = useState(false);

    useEffect(() => {
        if (modalEditarIsOpen) {
            setLoadingProdutos(true);
            api.get(`/api/marcas/${id}/produtos/`)
                .then(res => {
                    setProdutosMarca(res.data);
                })
                .catch(err => {
                    console.log("Erro ao carregar produtos:", err);
                })
                .finally(() => {
                    setLoadingProdutos(false);
                });
        }
    }, [modalEditarIsOpen, id]);

    const deletarMarca = async (event) => {
        event.preventDefault();
        try {
            const response = await api.get("/auth/users/me/");
            // eslint-disable-next-line no-unused-vars
            const bodyHistory = {
                user: response.data.id,
                model_name: nome,
                model_type: "Marca",
                operation: "-",
            };
            await api.post("/api/editionhistory/", bodyHistory);
            await api.delete("api/marcas/" + id + "/");
            toast.success("Marca removida com sucesso!", toastProps);
        } catch (error) {
            toast.error("Erro ao remover marca", toastProps);
        }
        setDeletarMarcaIsOpen(false);
        GetMarcas();
    };

    const editarMarca = async (event) => {
        event.preventDefault();
        setLoading(true);
        try {
            const response = await api.get("/auth/users/me/");
            // eslint-disable-next-line no-unused-vars
            const bodyHistory = {
                user: response.data.id,
                model_name: nome,
                model_type: "Marca",
                operation: "~",
            };
            await api.post("/api/editionhistory/", bodyHistory);
            const body = {
                nome: novoNome,
                descricao: novoDescricao,
                ...(novaImagemName !== "" && { image_url: novaImagemName })
            };

            await api.patch(`/api/marcas/${id}/`, body);
            toast.success("Marca alterada com sucesso!", toastProps);
        } catch {
            toast.error("Erro ao editar marca", toastProps);
        }

        setLoading(false);
        setModalEditarIsOpen(false);
        GetMarcas();
    };

    const putImagem = () => {
        if (!novaImagem.type) {
            return;
        }
        const typeNovo = novaImagem.type.substring([6]);
        console.log(typeNovo);
        setNovaImagemName("");
        setLoadingUpload(true);
        api
            .get("/api/file/upload/" + typeNovo + "/")
            .then(async (res) => {
                const formData = new FormData();
                formData.append("file_name", res.data.file_name);
                formData.append("file", novaImagem);
                console.log("res.data.file_name", res.data.file_name);
                api
                    .post("/api/file/upload/" + typeNovo + "/", formData)
                    .then((response) => {
                        api
                            .patch(`/api/marcas/${id}/`, {
                                image_url: res.data.file_name,
                            })
                            .then((response) => {
                                console.log();
                                setNovaImagemName(res.data.file_name); // Set aqui para usar no save final se quiser, ou ja salvou
                            })
                            .catch((err) => {
                                console.log(err);
                            });
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            })

            .catch((err) => console.error(err))
            .finally(() => setLoadingUpload(false));
    };

    return (
        <>
            <ListElement>
                <ContainerHeaderTable
                    width="80"
                    minWidth="100"
                    justify="start"
                    marginLeft={30}
                    marginRight={10}
                >
                    <TextTable onClick={() => setModalEditarIsOpen(true)}>
                        <b>{nome}</b>
                        {/* Opcional: mostrar descrição curta */}
                        {descricao && <span style={{ fontSize: '12px', color: '#666', marginLeft: '10px' }}>- {descricao.substring(0, 30)}...</span>}
                    </TextTable>
                </ContainerHeaderTable>

                <ContainerHeaderTable
                    // width="15"
                    minWidth="90"
                    justify="space-evenly"
                    marginLeft={0}
                    marginRight={30}
                >
                    <IconImage
                        width={20}
                        height={20}
                        src={edit}
                        onClick={() => setModalEditarIsOpen(true)}
                    ></IconImage>
                    <IconImage
                        width={20}
                        height={20}
                        src={Cancelar}
                        onClick={(e) => setDeletarMarcaIsOpen(true)}
                    ></IconImage>
                </ContainerHeaderTable>

                {modalEditarIsOpen && (
                    <Modal
                        container="containerEditarCategoria" // Pode criar um estilo especifico se precisar
                        onClose={() => setModalEditarIsOpen(false)}
                    >
                        <div id="divEditarCategoria">
                            <label
                                htmlFor="nome_marca"
                                style={{ fontSize: "20px", fontWeight: "bold" }}
                            >
                                Editar Marca
                            </label>
                            <TextDivModal height="40">
                                <TextAreaModal
                                    value={novoNome}
                                    onChange={(e) => setNovoNome(e.target.value)}
                                    id="nome_marca"
                                />
                            </TextDivModal>

                            <label htmlFor="desc_marca">Descrição</label>
                            <TextDivModal height="60">
                                <TextAreaModal
                                    value={novoDescricao || ""}
                                    onChange={(e) => setNovoDescricao(e.target.value)}
                                    id="desc_marca"
                                    style={{ height: '50px' }}
                                />
                            </TextDivModal>

                            {imagem && imagem !== "" ? (
                                <img src={imagem} width="200" height="200" alt={nome} />
                            ) : null}
                            <div style={{ height: "10px" }}>
                                <button
                                    style={{
                                        backgroundColor: "#E6AC86",
                                        border: "none",
                                        borderRadius: "10px",
                                        margin: "0 auto 20px auto !important",
                                        padding: "5px",
                                        paddingBottom: "10px",
                                        fontSize: "13px",
                                        color: "white",
                                        width: "100%", // corrigido de 100 % "!important"
                                        height: "25px",
                                    }}
                                    onClick={() => setChangeImageIn(!changeImageIn)}
                                >
                                    Alterar Imagem
                                </button>
                            </div>
                            {changeImageIn && (
                                <div id="divAlterarImagem">
                                    <input
                                        type="file"
                                        onChange={(event) => setNovaImagem(event.target.files[0])}
                                        accept="image/*"
                                    />
                                    <button onClick={() => putImagem()}>Confirmar imagem</button>
                                    {loadingUpload && (
                                        <ReactLoading
                                            type="spokes"
                                            color="#E6AC86"
                                            height={20}
                                            width={20}
                                        />
                                    )}
                                </div>
                            )}

                            {/* Section for displaying products */}
                            <div style={{ marginTop: "20px", borderTop: "1px solid #ccc", paddingTop: "10px", textAlign: "left" }}>
                                <label style={{ fontSize: "16px", fontWeight: "bold", display: "block", marginBottom: "10px" }}>Produtos desta Marca</label>
                                {loadingProdutos ? (
                                    <div style={{ display: "flex", justifyContent: "center", margin: "10px 0" }}>
                                        <ReactLoading type="spin" color="#E6AC86" height={20} width={20} />
                                    </div>
                                ) : produtosMarca.length > 0 ? (
                                    <ul className="custom-scrollbar" style={{ listStyle: "none", padding: "0 5px 0 0", maxHeight: "200px", overflowY: "auto" }}>
                                        {produtosMarca.map(p => (
                                            <li key={p.id} style={{ display: "flex", alignItems: "center", marginBottom: "10px", paddingBottom: "10px", borderBottom: "1px solid #eee" }}>
                                                {p.image_url ? (
                                                    <img src={p.image_url} alt={p.nome} style={{ width: "40px", height: "40px", objectFit: "cover", marginRight: "10px", borderRadius: "5px" }} />
                                                ) : (
                                                    <div style={{ width: "40px", height: "40px", backgroundColor: "#eee", marginRight: "10px", borderRadius: "5px" }}></div>
                                                )}
                                                <span style={{ fontSize: "14px" }}>{p.nome}</span>
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <p style={{ fontSize: "14px", color: "#666" }}>Nenhum produto cadastrado para esta marca.</p>
                                )}
                            </div>

                            <button
                                //value="Confirmar"
                                style={{ cursor: "pointer", marginTop: "20px" }}
                                onClick={(event) => editarMarca(event)}
                                className="enviar"
                            >
                                {loading ? (
                                    <ReactLoading
                                        type="spin"
                                        color="#fff"
                                        height={20}
                                        width={20}
                                    />
                                ) : (
                                    "Confirmar"
                                )}
                            </button>
                        </div>
                    </Modal>
                )}

                {deletarMarcaIsOpen ? (
                    <Modal
                        container="containerAvisoDeletar"
                        onClose={() => setDeletarMarcaIsOpen(false)}
                    >
                        <h2 id="textoDeletar">
                            Deseja mesmo deletar esta Marca de forma definitiva?
                        </h2>
                        <div id="botoesDeletar">
                            <button id="deletar" onClick={(e) => deletarMarca(e)}>
                                SIM
                            </button>
                            <button
                                id="deletar"
                                onClick={() => setDeletarMarcaIsOpen(false)}
                            >
                                NÃO
                            </button>
                        </div>
                    </Modal>
                ) : null}
            </ListElement>
        </>
    );
}
export default BoxMarca;
